import React, { useState, useEffect } from "react";
import { Title } from "../../components/styled/DownloadTemplate.styled";
import {
  UploadDocumentWrapper,
  BtnWrapper,
} from "../../components/styled/UploadDocument.styled";
import { Grid } from "@mui/material";
import StyledButton from "../../components/elements/StyledButton";
import { BiUpload } from "react-icons/bi";
import { HiChevronLeft } from "react-icons/hi";
import Loader from "../../components/elements/Loader";
import FileUpload from "../../components/FileUpload";
import { toast } from "react-toastify";
import { uploadFile } from "../../services/api/fileUpload";
import { initiateFile } from "../../services/api/newUpload.api";
import * as XLSX from "xlsx";
import { iSOnlyConsistsWithCommas } from "../../utils/helper";
import { getAllCountries } from "../../services/api/country.api";
import { updateFileStatus } from "../../services/api/newUpload.api";

export default function UploadDocument({
  onPrev,
  onNext,
  model,
  country,
  modelV,
  modelId,
  uploadId,
  setUploadId,
  selectedModelData,
}) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disableUpload, setDisableUpload] = useState(true);
  const [disableNext, setDisableNext] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));
  const [countries, setCountries] = useState([]);
  const hiddenFileInput = React.useRef(null);
  const maxUploadSize = 5000;

  useEffect(() => {
    const getCountries = async () => {
      try {
        setLoading(true);
        let response = await getAllCountries();
        setCountries(response);
        setLoading(false);
      } catch (err) {
        console.log(err);
        toast.error(err.message, { theme: "colored" });
        setLoading(false);
      }
    };
    getCountries();
    // eslint-disable-next-line
  }, []);

  function fileTextData() {
    if (model !== "init" && country !== "init" && modelV !== "init") {
      var fileTxtData = { module: model, version: modelV, country: country };
      var countryCode = undefined;
      countries.forEach((cty) => {
        if (country === cty.label) {
          countryCode = cty.code;
        }
      });
      const fileTxtDataString =
        "module=" +
        fileTxtData.module +
        ";version=" +
        fileTxtData.version +
        ";country=" +
        countryCode;
      return fileTxtDataString;
    }
  }

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onChangeFile = (event) => {
    const fileType = event.target.files[0].type;
    const [fileread] = event.target.files;
    const reader = new FileReader();
    if (
      fileType !== "application/vnd.ms-excel" &&
      fileType !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    )
      return toast.error("Invalid file type", { theme: "colored" });
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      var dataArray = data.split(/\r?\n/);
      const headerString = dataArray[0];
      var headerArray = headerString.split(",");
      let formattedHeaderArray = [];
      headerArray.forEach((item) => {
        if (item !== "" && item !== null) {
          formattedHeaderArray.push(item);
        }
      });
      let actualDataArrayLength = dataArray.length;
      dataArray.forEach((item) => {
        if (item === "" || iSOnlyConsistsWithCommas(item)) {
          actualDataArrayLength = actualDataArrayLength - 1;
        }
      });
      if (actualDataArrayLength > maxUploadSize) {
        return toast.error("Maximum upload size of 5000 lines exceeded", {
          theme: "colored",
        });
      }
      if (
        JSON.stringify(formattedHeaderArray) !==
        JSON.stringify(selectedModelData?.headers)
      ) {
        return toast.error("Headers do not match the template", {
          theme: "colored",
        });
      }
      setDisableUpload(false);
      setFile(event.target.files[0]);
    };
    reader.readAsBinaryString(fileread);
  };

  const onclickUpload = async () => {
    try {
      setLoading(true);
      const upload = await initiateFile({
        uploaded_file: {
          name: "data",
          url: "url",
        },
        template: {
          template_id: modelId,
          name: model,
        },
        user: {
          user_id: user._id,
          name: user.name,
        },
        version: modelV,
        country: country,
        updated_date: Date.now(),
        status: "processing",
      });
      const stringData = fileTextData();
      const fileText = new Blob([stringData], {
        type: "text/plain",
      });
      setUploadId(upload._id);
      const metadataLocation = encodeURI(upload._id + "/" + "metadata.txt");
      const excelURI = encodeURI(upload._id + "/" + upload._id + ".xlsx");
      try {
        await uploadFile({
          name: metadataLocation,
          file: fileText,
          type: fileText.type,
        });
        await uploadFile({
          name: excelURI,
          file: file,
          type: file.type,
        });
      } catch (err) {
        await updateFileStatus(upload._id, "ERROR");
      }
      setLoading(false);
      setDisableNext(false);
      onNext();
    } catch (err) {
      toast.error("Error uploading file", { theme: "colored" });
      setFile(null);
      setLoading(false);
    }
  };

  const onDeselectFile = async () => {
    setFile(null);
    hiddenFileInput.current.value = "";
  };

  return (
    <UploadDocumentWrapper>
      <Title>Upload Document</Title>
      <Grid
        container
        spacing={0}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Grid item xs={12} md={8}>
          <FileUpload
            title="Duly Filled Document"
            clickUpload={handleClick}
            file={file}
            onChangeFile={onChangeFile}
            hiddenFileInput={hiddenFileInput}
            onDeselectFile={onDeselectFile}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          {loading && <Loader />}
          {file && !loading && (
            <BtnWrapper>
              <StyledButton
                variant={"outlined"}
                iconLeft={<BiUpload />}
                onClick={onclickUpload}
                style={{ paddingLeft: "12px" }}
                disabled={disableUpload}
              >
                Upload Document
              </StyledButton>
            </BtnWrapper>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        spacing={0}
        justifyContent={"flex-end"}
        alignItems={"center"}
      >
        <Grid item xs={2}>
          <BtnWrapper>
            <StyledButton
              variant={"outlined"}
              iconLeft={<HiChevronLeft />}
              onClick={onPrev}
            >
              Previous
            </StyledButton>
          </BtnWrapper>
        </Grid>
      </Grid>
    </UploadDocumentWrapper>
  );
}
